import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import TitleAgentV2Store from '../../../stores/documentForms/titleAgentV2/titleAgentV2Store';
import TitleCompanySearch from './titleCompanySearch';
import TitleCompanyCreateForm from './titleCompanyCreateForm';

interface TitleAgentV2Props {
  store: TitleAgentV2Store;
}

const TitleAgentV2 = observer((props: TitleAgentV2Props) => {
  const { store } = props;
  const disabled = !store.canEdit;

  return (
    <Grid container spacing={3}>
      <TitleCompanySearch store={store} disabled={disabled} />
      <TitleCompanyCreateForm store={store} disabled={disabled} />
    </Grid>
  );
});

export default TitleAgentV2;
